import PropTypes from "prop-types";

import {
  descriptionCss,
  linksContainerCss,
} from "./LearnAboutClassRoster.style";

const propTypes = {
  hasBulkClassrooms: PropTypes.bool,
};

const LearnAboutClassRoster = ({ hasBulkClassrooms }) => {
  return (
    <>
      <p css={descriptionCss}>
        Learn more about automated class rostering with:
      </p>
      <ul role="list" css={linksContainerCss}>
        <li>
          <a
            href="https://support.newsela.com/article/sync-google-classes/"
            target="_blank"
            rel="noreferrer"
          >
            Google Classroom
          </a>
        </li>
        <li>
          <a
            href="https://support.newsela.com/article/ways-to-create-classes/#clever"
            target="_blank"
            rel="noreferrer"
          >
            Clever
          </a>
        </li>
        <li>
          <a
            href="https://support.newsela.com/article/ways-to-create-classes/#canvas"
            target="_blank"
            rel="noreferrer"
          >
            Canvas
          </a>
        </li>
        <li>
          <a
            href="https://support.newsela.com/article/ways-to-create-classes/#classlink"
            target="_blank"
            rel="noreferrer"
          >
            Classlink
          </a>
        </li>
        {!hasBulkClassrooms && (
          <li>
            <a
              href="https://support.newsela.com/article/ways-to-create-classes/#schoology"
              target="_blank"
              rel="noreferrer"
            >
              Schoology
            </a>
          </li>
        )}
      </ul>
    </>
  );
};

LearnAboutClassRoster.propTypes = propTypes;

export default LearnAboutClassRoster;
